import React, { Component } from 'react';
import './elo-report.scss';
import { ImageConstants, Constants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import HomeworkApi from '../../../../apis/homework'
import Loading from '../../../common/loading/loading';
import ReactTooltip from 'react-tooltip';

class HomeworkEvalutionReport extends Component {

    skillList = [
        {
            type: "COMPREHENSION",
            title: "Understanding the Question",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "MODELING",
            title: "Applying the right Concept",
            image: ImageConstants.MODELING,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "CALCULATION",
            title: "Ability to Calculate",
            image: ImageConstants.CALCULATION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "KNOWLEDGE",
            title: "KNOWLEDGE - Ability to remember formulas",
            image: ImageConstants.KNOWLEDGE,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        }
        ]

    state = {
        skillWiseReport: [],
        eloReport: [],
        students: [],
        totalUsers: 0,
        multiStepThershould : 0
    }

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension","slcs/thinking skills",
        'explain phenomena scientifically',
        'interpret scientific data and evidence critically',
        'interpret data and evidence scientifically',
        'Construct and evaluate designs for scientific enquiry',
        'remember',
        'application','conceptual understanding','analytical reasoning & interpretation',
        'visualization & representation','mathematical application','application to practical skills']

    componentDidMount() {
        this.getEloReport()
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }


    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ showStudentIndex: -1 })
        }
    }

    getEloReport(payload = {}) {
        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getEloReport(payload)
            .then(response => {

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                for (let i = 0; i < localSkillList.length; i++) {
                    let skill = localSkillList[i]
                    let detail = skillBaseReport[skill.type.toLowerCase()]
                    if (!detail) continue
                    skill.mastered = detail.correct || 0
                    skill.correctUsers = detail.correctUsers || []
                    skill.incorrectUsers = detail.incorrectUsers || []
                    skill.needImprovement = detail.incorrect
                    let total = detail.correct + detail.incorrect
                    skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                    skill.needImprovementPercentage = 100 - skill.masteredPercentage
                    result.push(skill)
                }

                console.log(result)

                this.setState({ skillWiseReport: result, multiStepThershould : response.multiStepThershould, 
                    eloReport: response.conceptBaseReport, totalUsers: response.totalUsers, isLoading: false })

            }).catch(err => {

                this.setState({ isLoading: false })
            })
    }

    getStudents(payload = {}) {
        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem?._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getStudentListForEloReport(payload)
            .then(response => {
                console.log("response response", response)
                this.setState({ isLoading: false, basePath: response.basePath, students: response?.users || [] })

            }).catch(err => {

                this.setState({ isLoading: false, students: [] })
            })
    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }


    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props?.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props?.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{`${this.props?.selectedItem?.chapter} >`}</span>
                <span className='pl-2'>{this.getDate(this.props?.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    onClickReportCardInfo = (type, students) => {

        let userIds = []

        for (let i = 0; i < students.length; i++) {
            userIds.push(students[i].userId)
        }

        this.setState({ showWrongAnswersReport: true, userIds, selectedStatus: type })
    }

    hideWrongAnswersReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    onClickStatus(item, index, status, reportType) {

        let payload = {
            status: status,
        }
        if (reportType === "SKILL_REPORT") {
            payload.reportType = reportType
            if (status == "CLEARED") {
                if (!item.correctUsers?.length) return
                payload.usersId = item.correctUsers.join(",")
            }
            else {
                if (!item.incorrectUsers?.length) return
                payload.usersId = item.incorrectUsers.join(",")
            }
        }

        if (item.eloId) {
            payload.eloId = item.eloId
        }
        this.getStudents(payload)
        this.setState({ seletedElo: item, showStudentIndex: index, reportType, status })

    }

    closeStudents() {
        this.setState({ selectedItem: null, showStudentIndex: -1, reload: true }, () => {
            this.setState({ reload: false })
        })
    }

    renderStudentCard(eloIndex, skillIndex, skillDetails, skillDetailsIndex, statusType) {
        let elo = this.state.eloReport[this.state.eloReport.length - 1]
        let skills = elo.skill

        let lastSkillIndex = 0

        for (let index = 0; index < this.orderedSkills.length; index++) {
            let key = this.orderedSkills[index]
            let skillDetails = skills[key]

            if (!skillDetails) continue

            lastSkillIndex = index
        }

        // console.log(lastSkillIndex)

        // console.log(this.state.eloReport.length - 1, eloIndex, lastSkillIndex, skillIndex, skillDetails.length - 1, skillDetailsIndex)

        return (
            <div className={`students-card ${this.state.eloReport.length - 1 === eloIndex &&
                lastSkillIndex === skillIndex &&
                skillDetails.length - 1 === skillDetailsIndex ? "position-at-top" : ""
                }`} ref={ref => this.studentRef = ref}>
                <div className='position-relative student-card-header-wrapper'>
                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.WRONG)} />
                        </div>
                    </div>
                    <div className='status-title'>{statusType}</div>
                </div>

                <div className='min-height-for-student-list'>
                    {this.state.students && this.state.students.length ? this.state.students.map((item, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {item.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                    }
                </div>

            </div>
        )
    }



    renderSkillWiseReport() {
        return (
            <div className="pt-4">
                <div className="table-title">By Skill</div>

                <div id="table-scoll" className=" mt-4" style={{ background: "rgb(245, 246, 250)" }}>
                    <table className="table cw-table">
                        <thead>
                            <tr>
                                <th className='th-left-radius pl-5'> Skills</th>
                                <th className="text-center td-max-width">Mastered</th>
                                <th className="th-right-radius text-center td-max-width">Need Improvements</th>

                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.skillWiseReport?.length ?
                                    this.state.skillWiseReport.map((item, index) => (

                                        <tr className="mt-4">
                                            <td className="pl-5">
                                                <span>
                                                    <img className="skill-img" src={getImageSource(item.image)} /><b className="pl-2">{item.title}</b>
                                                </span>
                                            </td>
                                            <td className="text-center mastered  td-max-width">
                                                <div className="cursor-pointer" onClick={() => this.onClickStatus(item, index, "CLEARED", "SKILL_REPORT")}>
                                                    <span className="text-1">
                                                        {item.mastered || 0}
                                                    </span>
                                                    <span className="skill-percentage">
                                                        {item.masteredPercentage || 0} %
                                                    </span>
                                                </div>

                                                {
                                                    this.state.seletedElo?.eloId === item.eloId && this.state.status === "CLEARED" && this.state.reportType === "SKILL_REPORT" && this.state.showStudentIndex === index ? this.renderStudentCard(0, 0, [], 0, "Mastered") : ""
                                                }

                                            </td>
                                            <td className="text-center need-improvement  td-max-width">
                                                <div className="cursor-pointer relative" onClick={() => this.onClickStatus(item, index, "NOT_CLEARED", "SKILL_REPORT")}>
                                                    <span className="text-1">{item.needImprovement || 0}</span>
                                                    <span className="skill-percentage">
                                                        {item.needImprovementPercentage || 0} %
                                                    </span>
                                                </div>

                                                {
                                                    this.state.seletedElo?.eloId === item.eloId && this.state.status === "NOT_CLEARED" && this.state.reportType === "SKILL_REPORT" && this.state.showStudentIndex === index ? this.renderStudentCard(0, 0, [], 0, "Need Improvements") : ""
                                                }
                                            </td>
                                        </tr>
                                    ))
                                    : <tr className="bg-white pt-4"><td colSpan="3" align='center'>No Records found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
                {
                    this.state.multiStepThershould ? <div className='text-right percentage-text'>{`( TV ${this.state.multiStepThershould}% is Mastered )`}</div> : ''
                }
                
            </div>
        )
    }


    renderEloReportTableBody(elo, eloIndex) {

        let arr = []
        if (elo.skill == "modelling") elo.skill = "modeling"
        let skills = elo.skill
        for (let index = 0; index < this.orderedSkills.length; index++) {
            let key = this.orderedSkills[index]
            let skillDetails = skills[key]

            if (!skillDetails) continue

            if (skillDetails && skillDetails.length) {
                // arr.push(
                //     <tr className="mt-4">
                //         <td className="skill-title pl-5" colSpan="4">
                //             <span>
                //                 <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} /><b className="pl-4">{key.toUpperCase()}</b>
                //             </span>
                //         </td>
                //     </tr>
                // )


                for (let i = 0; i < skillDetails.length; i++) {
                    let item = skillDetails[i]
                    let notAttempted = this.state.totalUsers - ((item.incorrect || 0) + (item.correct || 0))
                    arr.push(
                        <tr className="mt-4" key={item.eloId} onMouseEnter={ReactTooltip.rebuild}>
                            <td className="pl-5 position-relative">
                                <span>
                                    <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])}
                                        data-tip={key.toUpperCase()} />
                                </span>
                                <span>{item.title}</span>
                                <span className='position-absolute elo-tv' style={{
                                }}>{`TV = ${item.eloThreshold}%`}</span>
                            </td>
                            <td className="text-center mastered  td-max-width">

                                <div className="cursor-pointer" onClick={() => item.correct ? this.onClickStatus(item, i, "CLEARED", "ELO_REPORT") : ""}>
                                    <span className="text-1">
                                        {item.correct || 0}
                                    </span>
                                    <span className="skill-percentage">
                                        {this.calculatePercentage(item.correct, this.state.totalUsers) || 0} %
                                    </span>
                                </div>
                                {
                                    this.state.seletedElo?.eloId === item.eloId && this.state.status === "CLEARED" && this.state.reportType === "ELO_REPORT" && this.state.showStudentIndex === i ? this.renderStudentCard(eloIndex, index, skillDetails, i, "Understood") : ""
                                }
                            </td>
                            <td className="text-center need-improvement  td-max-width">
                                <div className="cursor-pointer" onClick={() => item.incorrect ? this.onClickStatus(item, i, "NOT_CLEARED", "ELO_REPORT") : ""}>
                                    <span className="text-1">{item.incorrect || 0}</span>
                                    <span className="skill-percentage">
                                        {this.calculatePercentage(item.incorrect, this.state.totalUsers) || 0} %
                                    </span>
                                </div>
                                {
                                    this.state.seletedElo?.eloId === item.eloId && this.state.status === "NOT_CLEARED" && this.state.reportType === "ELO_REPORT" && this.state.showStudentIndex === i ? this.renderStudentCard(eloIndex, index, skillDetails, i, "Not Understood") : ""
                                }
                            </td>
                            <td className="text-center not-attempted td-max-width">
                                <div className="cursor-pointer" onClick={() => notAttempted ? this.onClickStatus(item, i, "NOT_ATTEMPTED", "ELO_REPORT") : ""}>
                                    <span className="text-1">{notAttempted || 0}</span>
                                    <span className="skill-percentage">
                                        {this.calculatePercentage(notAttempted, this.state.totalUsers) || 0} %
                                    </span>
                                </div>
                                <div className="relative">
                                    {
                                        this.state.seletedElo?.eloId === item.eloId && this.state.status === "NOT_ATTEMPTED" && this.state.reportType === "ELO_REPORT" && this.state.showStudentIndex === i ? this.renderStudentCard(eloIndex, index, skillDetails, i, "Not Attempted") : ""
                                    }
                                </div>
                            </td>
                        </tr>
                    )
                }
            }

        }
        return arr
    }

    renderEloReport() {

        let eloList = this.state.eloReport

        return (
            <div className="pt-4">
                <div className="table-title">By Learning Outcomes</div>
                <div className='text-right tv-text'>TV = Threshold Value</div>
                {
                    eloList.length ?

                        eloList.map((item, index) => (

                            <div id="table-scoll" className=""
                                onMouseEnter={ReactTooltip.rebuild}>
                                <table className="table cw-table bordered-table" style={{ background: "rgb(245, 246, 250)" }}>
                                    <thead>
                                        <tr>
                                            <th className='th-left-radius pl-5'>{item.conceptName}</th>
                                            <th className="text-center td-max-width">Understood</th>
                                            <th className="text-center td-max-width">Not Understood</th>
                                            <th className="th-right-radius text-center td-max-width">Not Attempted</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white">
                                        {!this.state.reload ?
                                            this.renderEloReportTableBody(item, index)
                                            : ""
                                        }
                                    </tbody>
                                </table>
                            </div>
                        ))
                        : ""
                }
            </div>
        )
    }

    render() {

        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='elo-report-1'>



                    {/* <span className='screen-title-1'>LEARNING GAP REPORT</span>
                    <span>{this.renderBreadcrumb()}</span> */}

                    <div className='mb-3 item1'>
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>

                    <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.RECOMMENDATION_REPORT_CIRCLE)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    <span className='screen-title-1'>Learning Gap Report</span>
                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        {
                            this.renderSkillWiseReport()
                        }
                    </div>
                    <div className=''>
                        {
                            this.renderEloReport()
                        }
                    </div>
                    <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                        multiline={true}
                        place='right'
                        type='light' effect='solid'
                        event="mouseover mouseenter"
                        eventOff="mouseleave mouseout scroll mousewheel blur" />

                </div >
            </>);
    }
}

export default HomeworkEvalutionReport;